import script from "./TeacherClasses.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherClasses.vue?vue&type=script&setup=true&lang=js"

import "@/assets/common.css?vue&type=style&index=0&lang=css&external"
import "./TeacherClasses.vue?vue&type=style&index=1&id=97e51a92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97e51a92"]])

export default __exports__